






import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import GetIdentifyData from '@/utils/identifyFields/countries'
import IdentifyInputsRenderer from '@/components/IdentifyWizard/IdentifyInputsRenderer.vue'
import { ContextState, User, Config } from '@/store/context/contextTypes'
import { ProviderType } from '@/utils/identifyFields/providers/providerTypes'
import JavascriptAPI from '@/utils/JavascriptAPI'

// define used modules
const _CONTEXT_: string = 'context'

@Component({
  props: {
    handleInputValue: { type: Function, required: true }
  },
  computed: {
    ...mapState({
      userWizardData: (state: any): User => state.context.userWizardData,
      identifyWizardStep: (state: any): User => state.context.identifyWizardStep,
      config: (state: any): object => state.context.config,
      isLoading: (state: any): boolean => state.context.isLoading
    })
  },
  components: {
    IdentifyInputsRenderer
  }
})
export default class IdentityWizard extends Vue {
  config: Config
  identifyWizardStep: number
  selectedProvider: ProviderType
  wizardFields: Array<object>
  isLoading: Boolean
  @State('context') context: ContextState
  @Action('setIdentifyWizardStep', { namespace: _CONTEXT_ }) setIdentifyWizardStep: any

  beforeMount () {
    // We assign this to local state since we don't need to filter+sort all available fields based on config more than once
    this.getSelectedProvider()
  }

  // computed
  getSelectedProvider () {
    const { country, identifyFields } = this.config
    this.selectedProvider = GetIdentifyData[country](identifyFields)
    this.wizardFields = this.selectedProvider.fields
  }

  // Have to put this as a getter to get it working with the debounce-method
  handleInputChange (e, fieldIndex) {
    const fieldConfig: any = this.wizardFields[fieldIndex]
    if (this.identifyWizardStep > fieldIndex) {
      this.setIdentifyWizardStep(fieldIndex) // when changing the previous field - reset the wizard step one back
    }
    return this.$props.handleInputValue(e, fieldConfig, fieldIndex)
  }
}
